// Cart Drawer - Panier latéral rapide
(function() {
  'use strict';
  
  const drawer = document.getElementById('cart-drawer');
  const cartToggle = document.querySelector('[data-cart-toggle]');
  const cartCount = document.querySelector('[data-cart-count]');
  
  if (!drawer) return;
  
  // Ouvrir le drawer
  function openCartDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    loadCart();
  }
  
  // Fermer le drawer
  function closeCartDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  
  // Variable globale pour stocker la devise du panier
  let cartCurrency = 'EUR';
  
  // Charger le contenu du panier
  function loadCart() {
    const loading = drawer.querySelector('[data-cart-loading]');
    const empty = drawer.querySelector('[data-cart-empty]');
    const content = drawer.querySelector('[data-cart-content]');
    const itemsContainer = drawer.querySelector('[data-cart-items]');
    const subtotal = drawer.querySelector('[data-cart-subtotal]');
    
    if (loading) loading.style.display = 'flex';
    if (empty) empty.style.display = 'none';
    if (content) content.style.display = 'none';
    
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        // Mettre à jour la devise du panier
        if (cart.currency) {
          cartCurrency = cart.currency;
        }
        updateCartCount(cart.item_count);
        
        if (loading) loading.style.display = 'none';
        
        if (cart.items.length === 0) {
          if (empty) empty.style.display = 'flex';
          if (content) content.style.display = 'none';
          loadRecommendedProducts();
        } else {
          if (empty) empty.style.display = 'none';
          if (content) content.style.display = 'flex';
          
          // Rendre les items
          if (itemsContainer) {
            itemsContainer.innerHTML = cart.items.map(item => `
              <div class="cart-item" data-cart-item="${item.key}">
                <img src="${item.image}" alt="${item.title}" class="cart-item__image" loading="lazy">
                <div class="cart-item__details">
                  <h3 class="cart-item__title">${escapeHtml(item.product_title)}</h3>
                  ${item.variant_title ? `<p class="cart-item__variant">${escapeHtml(item.variant_title)}</p>` : ''}
                  <div class="cart-item__quantity">
                    <button class="cart-item__qty-btn" data-cart-decrease="${item.key}">−</button>
                    <input type="number" class="cart-item__qty-input" value="${item.quantity}" min="1" data-cart-qty="${item.key}">
                    <button class="cart-item__qty-btn" data-cart-increase="${item.key}">+</button>
                  </div>
                  <button class="cart-item__remove" data-cart-remove="${item.key}">Supprimer</button>
                </div>
                <div class="cart-item__price">${item.line_price_formatted || formatMoney(item.line_price)}</div>
              </div>
            `).join('');
            
            // Ajouter les event listeners
            setupCartItemListeners(cart);
          }
          
          // Mettre à jour le sous-total (utiliser le prix formaté de Shopify qui inclut la devise)
          if (subtotal) {
            subtotal.textContent = cart.total_price_formatted || formatMoney(cart.total_price);
          }
        }
      })
      .catch(err => {
        console.error('Erreur chargement panier:', err);
        if (loading) loading.style.display = 'none';
        if (empty) empty.style.display = 'flex';
      });
  }
  
  // Configurer les listeners pour les items
  function setupCartItemListeners(cart) {
    // Augmenter quantité
    drawer.querySelectorAll('[data-cart-increase]').forEach(btn => {
      btn.addEventListener('click', function() {
        const key = this.getAttribute('data-cart-increase');
        updateQuantity(key, 1);
      });
    });
    
    // Diminuer quantité
    drawer.querySelectorAll('[data-cart-decrease]').forEach(btn => {
      btn.addEventListener('click', function() {
        const key = this.getAttribute('data-cart-decrease');
        updateQuantity(key, -1);
      });
    });
    
    // Modifier quantité manuellement
    drawer.querySelectorAll('[data-cart-qty]').forEach(input => {
      input.addEventListener('change', function() {
        const key = this.getAttribute('data-cart-qty');
        const qty = parseInt(this.value, 10) || 1;
        updateQuantity(key, 0, qty);
      });
    });
    
    // Supprimer item
    drawer.querySelectorAll('[data-cart-remove]').forEach(btn => {
      btn.addEventListener('click', function() {
        const key = this.getAttribute('data-cart-remove');
        removeItem(key);
      });
    });
  }
  
  // Mettre à jour la quantité
  function updateQuantity(key, change, absoluteQty) {
    const item = Array.from(drawer.querySelectorAll('[data-cart-item]')).find(el => el.getAttribute('data-cart-item') === key);
    if (!item) return;
    
    const currentQty = parseInt(item.querySelector('[data-cart-qty]').value, 10) || 1;
    const newQty = absoluteQty !== undefined ? Math.max(1, absoluteQty) : Math.max(1, currentQty + change);
    
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty })
    })
      .then(res => res.json())
      .then(() => {
        loadCart();
        updateCartCountSilently();
      })
      .catch(err => {
        console.error('Erreur mise à jour quantité:', err);
        loadCart();
      });
  }
  
  // Supprimer un item
  function removeItem(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(res => res.json())
      .then(() => {
        loadCart();
        updateCartCountSilently();
      })
      .catch(err => {
        console.error('Erreur suppression item:', err);
        loadCart();
      });
  }
  
  // Mettre à jour le compteur
  function updateCartCount(count) {
    if (cartCount) {
      if (count > 0) {
        cartCount.textContent = count;
        cartCount.style.display = '';
      } else {
        cartCount.style.display = 'none';
      }
    }
  }
  
  // Formater l'argent avec la devise du marché
  function formatMoney(cents) {
    // Utiliser la devise du panier (mise à jour à chaque chargement du panier)
    const currency = cartCurrency || 'EUR';
    const locale = document.documentElement.lang || 'fr-FR';
    
    // Adapter la locale selon la devise pour un meilleur formatage
    let formatLocale = locale;
    if (currency === 'USD') formatLocale = 'en-US';
    else if (currency === 'GBP') formatLocale = 'en-GB';
    else if (currency === 'CHF') formatLocale = 'de-CH';
    
    return new Intl.NumberFormat(formatLocale, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(cents / 100);
  }
  
  // Échapper HTML
  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }
  
  // Event listeners
  if (cartToggle) {
    cartToggle.addEventListener('click', openCartDrawer);
  }
  
  drawer.querySelectorAll('[data-cart-close]').forEach(el => {
    el.addEventListener('click', closeCartDrawer);
  });
  
  // Fermer avec Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') {
      closeCartDrawer();
    }
  });
  
  // Gérer les formulaires "Ajouter au panier"
  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (!form.hasAttribute('action') || !form.getAttribute('action').includes('/cart/add')) return;
    
    e.preventDefault();
    
    const formData = new FormData(form);
    
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
      .then(res => res.json())
      .then(() => {
        updateCartCountSilently();
        openCartDrawer();
      })
      .catch(err => {
        console.error('Erreur ajout au panier:', err);
        alert('Une erreur est survenue lors de l\'ajout au panier.');
      });
  });
  
  // Mettre à jour le compteur uniquement après des actions (pas de polling agressif)
  function updateCartCountSilently() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => updateCartCount(cart.item_count))
      .catch(() => {});
  }
  
  // Mettre à jour le compteur au chargement initial
  updateCartCountSilently();
  
  // Charger les produits recommandés
  function loadRecommendedProducts() {
    const recommendedList = drawer.querySelector('[data-cart-recommended-list]');
    if (!recommendedList) return;
    
    // Récupérer les produits depuis la collection "nos-produits"
    // Utiliser l'API Storefront pour obtenir les prix corrects
    fetch('/collections/nos-produits/products.json?limit=20')
      .then(res => {
        if (!res.ok) {
          console.error('Collection non trouvée ou erreur:', res.status);
          return { products: [] };
        }
        return res.json();
      })
      .then(data => {
        if (!data.products || data.products.length === 0) {
          console.log('Aucun produit trouvé dans la collection "nos-produits"');
          return;
        }
        
        // Filtrer uniquement les produits disponibles avec une variante disponible
        const availableProducts = data.products
          .filter(product => {
            // Vérifier que le produit a au moins une variante disponible
            return product.variants && product.variants.length > 0 && 
                   product.variants.some(v => v.available);
          })
          .slice(0, 6); // Prendre les 6 premiers produits disponibles
        
        if (availableProducts.length === 0) {
          console.log('Aucun produit disponible dans la collection');
          return;
        }
        
        recommendedList.innerHTML = availableProducts.map(product => {
          // Trouver la première variante disponible
          const variant = product.variants.find(v => v.available) || product.variants[0];
          if (!variant || !variant.available) return '';
          
          // Extraire le prix correctement depuis la variante
          // Dans products.json de Shopify, les prix sont TOUJOURS en centimes
          // Mais parfois l'API peut retourner "24" pour 24.00€ au lieu de "2400" centimes
          // Il faut vérifier la valeur et le format
          let price = 'N/A';
          let priceValue = null;
          
          // Priorité 1: variant.price
          if (variant.price !== undefined && variant.price !== null && variant.price !== '') {
            priceValue = typeof variant.price === 'string' ? parseFloat(variant.price) : variant.price;
          }
          // Priorité 2: product.price
          else if (product.price !== undefined && product.price !== null && product.price !== '') {
            priceValue = typeof product.price === 'string' ? parseFloat(product.price) : product.price;
          }
          // Priorité 3: product.variants[0].price
          else if (product.variants && product.variants.length > 0 && product.variants[0].price) {
            priceValue = typeof product.variants[0].price === 'string' 
              ? parseFloat(product.variants[0].price) 
              : product.variants[0].price;
          }
          
            // Convertir de centimes en devise du marché
            // Dans l'API products.json, les prix DEVRAIENT être en centimes
            // Mais si on voit 0,24€ au lieu de 23,99€, c'est que l'API retourne "24" au lieu de "2399"
            // Solution: détecter si le prix est < 1000 (anormalement bas pour un produit)
            // Si c'est le cas, on multiplie par 100 avant de diviser par 100
            if (priceValue !== null && !isNaN(priceValue) && priceValue > 0) {
              // Si le prix est < 1000 et > 0, c'est probablement un prix déjà divisé par 100
              // Par exemple: 24 au lieu de 2399 (pour 23,99€)
              // Dans ce cas, on multiplie par 100 pour obtenir les centimes, puis on divise par 100
              if (priceValue < 1000 && priceValue > 0) {
                // Prix probablement déjà en format décimal (ex: 24 pour 24.00€)
                // On multiplie par 100 pour obtenir les centimes, puis on divise par 100
                priceValue = priceValue * 100;
              }
              
              // Utiliser formatMoney pour avoir la bonne devise
              price = formatMoney(priceValue);
            }
          
          // Extraire l'image correctement depuis l'API products.json
          let imageUrl = '';
          
          // Méthode 1: featured_image (string URL)
          if (product.featured_image) {
            imageUrl = product.featured_image;
            // S'assurer que c'est une URL complète
            if (!imageUrl.startsWith('http')) {
              imageUrl = 'https:' + imageUrl;
            }
          }
          // Méthode 2: images array (première image)
          else if (product.images && product.images.length > 0) {
            const firstImage = product.images[0];
            if (typeof firstImage === 'string') {
              imageUrl = firstImage.startsWith('http') ? firstImage : 'https:' + firstImage;
            } else if (firstImage.src) {
              imageUrl = firstImage.src.startsWith('http') ? firstImage.src : 'https:' + firstImage.src;
            } else if (firstImage.url) {
              imageUrl = firstImage.url.startsWith('http') ? firstImage.url : 'https:' + firstImage.url;
            }
          }
          // Méthode 3: image (propriété directe)
          else if (product.image) {
            imageUrl = typeof product.image === 'string' 
              ? (product.image.startsWith('http') ? product.image : 'https:' + product.image)
              : (product.image.src || product.image.url || product.image);
            if (imageUrl && !imageUrl.startsWith('http')) {
              imageUrl = 'https:' + imageUrl;
            }
          }
          
          // Image par défaut si aucune image trouvée
          if (!imageUrl) {
            imageUrl = 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-product-1_large.png';
          }
          
          return `
            <div class="cart-drawer__recommended-item" data-product-id="${product.id}" data-variant-id="${variant.id}">
              <img src="${imageUrl}" alt="${escapeHtml(product.title)}" class="cart-drawer__recommended-image" loading="lazy" onerror="this.src='https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-product-1_large.png'">
              <h4 class="cart-drawer__recommended-name">${escapeHtml(product.title)}</h4>
              ${variant.title && variant.title !== 'Default Title' ? `<p class="cart-drawer__recommended-variant">${escapeHtml(variant.title)}</p>` : ''}
              <div class="cart-drawer__recommended-price">${price}</div>
              <div class="cart-drawer__recommended-qty">
                <button class="cart-drawer__recommended-qty-btn" data-recommended-decrease="${product.id}">−</button>
                <input type="number" class="cart-drawer__recommended-qty-input" value="1" min="1" data-recommended-qty="${product.id}">
                <button class="cart-drawer__recommended-qty-btn" data-recommended-increase="${product.id}">+</button>
              </div>
              <button class="cart-drawer__recommended-add" data-recommended-add="${product.id}">Ajouter</button>
            </div>
          `;
        }).filter(html => html !== '').join('');
        
        // Ajouter les event listeners pour les produits recommandés
        setupRecommendedListeners();
      })
      .catch(err => {
        console.error('Erreur chargement produits recommandés:', err);
      });
  }
  
  // Configurer les listeners pour les produits recommandés
  function setupRecommendedListeners() {
    // Boutons quantité
    drawer.querySelectorAll('[data-recommended-increase]').forEach(btn => {
      btn.addEventListener('click', function() {
        const productId = this.getAttribute('data-recommended-increase');
        const input = drawer.querySelector(`[data-recommended-qty="${productId}"]`);
        if (input) {
          const current = parseInt(input.value, 10) || 1;
          input.value = current + 1;
        }
      });
    });
    
    drawer.querySelectorAll('[data-recommended-decrease]').forEach(btn => {
      btn.addEventListener('click', function() {
        const productId = this.getAttribute('data-recommended-decrease');
        const input = drawer.querySelector(`[data-recommended-qty="${productId}"]`);
        if (input) {
          const current = parseInt(input.value, 10) || 1;
          input.value = Math.max(1, current - 1);
        }
      });
    });
    
    // Boutons ajouter au panier
    drawer.querySelectorAll('[data-recommended-add]').forEach(btn => {
      btn.addEventListener('click', function() {
        const productId = this.getAttribute('data-recommended-add');
        const item = drawer.querySelector(`[data-product-id="${productId}"]`);
        const variantId = item?.getAttribute('data-variant-id');
        const qtyInput = drawer.querySelector(`[data-recommended-qty="${productId}"]`);
        const quantity = parseInt(qtyInput?.value, 10) || 1;
        
        if (!variantId) {
          alert('Variant non disponible');
          return;
        }
        
        // Désactiver le bouton pendant l'ajout
        this.disabled = true;
        this.textContent = 'Ajout...';
        
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: variantId,
            quantity: quantity
          })
        })
          .then(res => res.json())
          .then(() => {
            updateCartCountSilently();
            loadCart(); // Recharger le panier pour afficher le nouveau produit
          })
          .catch(err => {
            console.error('Erreur ajout produit:', err);
            alert('Une erreur est survenue lors de l\'ajout au panier.');
            this.disabled = false;
            this.textContent = 'Ajouter';
          });
      });
    });
  }
})();

